import React from 'react';

import { Container } from './styles';
import { logo } from '../../config';

interface ILoaderProps {
  message: string;
  position?: 'fixed' | 'relative' | 'absolute';
}

const Loader: React.FC<ILoaderProps> = ({
  message = 'Carregando...',
  position = 'fixed',
}) => {
  return (
    <Container position={position}>
      <aside style={{ margin: '10px auto', background: '#fff', borderRadius: '10px', padding: '10px' }}>
        <img style={{ width: '200px' }} alt="Plataforma Online" src={logo} />
      </aside>
      <p style={{ margin: '10px auto', color: '#333', background: '#fff', borderRadius: '10px', padding: '5px 10px' }}>{message}</p>
    </Container>
  );
};

interface ILoaderWithElementProps {
  message: JSX.Element;
  position?: 'fixed' | 'relative' | 'absolute';
}

export const LoaderWithElement: React.FC<ILoaderWithElementProps> = ({
  message = <>Carregando...</>,
  position = 'fixed',
}) => {
  return (
    <Container position={position}>
      <aside style={{ margin: '10px auto', background: '#fff', borderRadius: '10px', padding: '10px' }}>
        <img style={{ width: '200px' }} alt="Plataforma Online" src={logo} />
      </aside>
      <p style={{ margin: '10px auto', color: '#333', background: '#fff', borderRadius: '10px', padding: '5px 10px' }}>{message}</p>
    </Container>
  );
};

export default Loader;
